export class Button {
  constructor(difference) {
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.styleId = 1
    this.width = 100
    this.height = 40
    this.top = 10
    this.left = 10
    this.innerElement = "cxButton"
    this.content = "按钮"
    this.contentHasLimit = true
    this.textLimitLines = 8
    this.openBlankPage = true
    this.linkUrl = ""
    this.internalLinkName = ""
    this.accessRulers = []
    this.fontFamily = "sans-serif"
    this.fontSize = 14
    this.lineHeight = 14
    this.fontWeight = 600
    this.bgColor = "rgb(61, 130, 242)"
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.imgSrc = "http://146394rh.mh.chaoxing.com/engine/upload/engine/2021-04/20210407152144481e.jpg"
    this.color = "rgba(255,255,255,1)"
    this.textIsThemeColor = false
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.rotate = 0
    this.textDecoration = "none"
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderBottomRightRadius = 0
    this.borderColor = "#3D82F2"
    this.borderWidth = 1
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    // 阴影
    this.textShadowColor = ["rgba(255,255,255,0)"]
    this.textShadowH = [0]
    this.textShadowV = [0]
    this.textShadowBlur = [0]
    this.iconPosition = "left" // left,right
    this.iconSrc = ""
    this.iconType = "img" // img,icon 图片和字体图标
    this.hoverIconSrc = "611F4ADD5D8607EA"
    this.clickIconSrc = "611F4ADD5D8607EA"
    this.iconSrcType = 0   //  0表示默认状态 使用iconSrc  1表示鼠标悬浮状态 使用hoverIconSrc    2表示鼠标点击状态 使用clickIconSrc
    this.iconWidth = 14
    this.iconMargin = 10
    this.iconColorIsThemeColor = false
    this.iconColor = "#444444"
    this.opacity = 1
    this.cursorType = "pointer"
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}